
export default function PartnersSection() {
  const partners = [
    {
      id: 1,
      name: 'TruVision',
      logo: 'https://static.readdy.ai/image/686bee9df6fcbede85637f4fe190f1d8/482eff515df7de1c0c92d1922282a37a.png',
      description: 'Solutions de vidéosurveillance avancées',
      specialties: ['Caméras IP', 'Enregistreurs numériques', 'Logiciels de gestion']
    },
    {
      id: 2,
      name: 'Dahua Technology',
      logo: 'https://static.readdy.ai/image/686bee9df6fcbede85637f4fe190f1d8/1cea27ab82c91015d8d9c1f25f67f2e2.jfif',
      description: 'Caméras intelligentes et systèmes d\'accès',
      specialties: ['Caméras IA', 'Contrôle d\'accès', 'Analyse vidéo']
    },
    {
      id: 3,
      name: 'AIR fire worldwide',
      logo: 'https://static.readdy.ai/image/686bee9df6fcbede85637f4fe190f1d8/0d9bcbc1eb2d6b5a6db107553c9399e3.jfif',
      description: 'Systèmes de détection et extinction incendie',
      specialties: ['Détection incendie', 'Extinction automatique', 'Alarmes incendie']
    }
  ];

  return (
    <section id="partenaires" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos <span className="text-red-600">Partenaires</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Nous collaborons avec les leaders mondiaux de la sécurité pour vous offrir 
            les meilleures solutions technologiques du marché.
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 group"
            >
              {/* Logo */}
              <div className="h-20 flex items-center justify-center mb-6 bg-white rounded-xl p-4">
                <img
                  src={partner.logo}
                  alt={`${partner.name} Logo`}
                  className="max-h-full max-w-full object-contain"
                />
              </div>

              {/* Content */}
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                  {partner.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {partner.description}
                </p>

                {/* Specialties */}
                <div className="space-y-2">
                  {partner.specialties.map((specialty, index) => (
                    <div
                      key={index}
                      className="inline-block bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-medium mr-2 mb-2"
                    >
                      {specialty}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center bg-red-50 border border-red-200 rounded-full px-6 py-3">
            <i className="ri-award-line text-red-600 text-xl mr-3"></i>
            <span className="text-red-800 font-semibold">
              25+ Années d'Expérience avec les Meilleurs Partenaires
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}